import type { Locale, LocaleCodeType } from "@partners/ui";

import { defaultLocales, LanguageSelector } from "@partners/ui";
import { useTranslation } from "react-i18next";

import { useGlobalAnalytics } from "@/hooks/analytics";
import { supportedLocales } from "@/i18n/config";
import { logger } from "@/utils/logger";

export const LanguageSwitcher = ({
  isMobileVersion,
}: {
  isMobileVersion?: boolean;
}) => {
  const locales = Object.values(defaultLocales).filter((locale) =>
    supportedLocales.includes(locale.code),
  );

  const { i18n } = useTranslation();
  const {
    trackLanguageSelectorHeaderEvent,
    trackLanguageSelectorMobileMenuEvent,
  } = useGlobalAnalytics();

  const handleChangeLanguage = (locale: Locale) => {
    // Preload resources first so changeLanguage resolves synchronously.
    // Without this, navigating before the async load finishes causes the new
    // page to briefly render in the previous language.
    i18n
      .loadLanguages([locale.code])
      .then(() => i18n.changeLanguage(locale.code))
      .catch((error) => logger.error(error));

    if (isMobileVersion) {
      trackLanguageSelectorMobileMenuEvent(locale.label);
      return;
    }

    trackLanguageSelectorHeaderEvent(locale.label);
  };

  return (
    <LanguageSelector
      isMobileVersion={isMobileVersion}
      currentLocale={i18n.language as LocaleCodeType}
      locales={locales}
      onChange={handleChangeLanguage}
    />
  );
};
